import common from 'components/Common/en.json';

import accountabilitySystemAnalytics from 'modules/AccountabilitySystemAnalytics/en.json';
import accountabilitySystemSetup from 'modules/AccountabilitySystemSetup/en.json';
import accountSettings from 'modules/AccountSettings/en.json';
import accountSetupV2 from 'modules/AccountSetupV2/en.json';
import activityTaskExperience from 'modules/ActivityTaskExperience/en.json';
import alumniSurveys from 'modules/AlumniSurveys/en.json';
import alumniTakingSurveys from 'modules/AlumniTakingSurveys/en.json';
import assessments from 'modules/Assessments/en.json';
import authentication from 'modules/Authentication/en.json';
import careerCenter from 'modules/CareerCenter/en.json';
import collegeCosts from 'modules/CollegeCosts/en.json';
import courseCatalog from 'modules/CourseCatalog/en.json';
import courseCatalogDistrictConfig from 'modules/CourseCatalogDistrictConfig/en.json';
import coursePlanner from 'modules/CoursePlanner/en.json';
import coursePlanning from 'modules/CoursePlanning/en.json';
import credentialWallet from 'modules/CredentialWallet/en.json';
import digitalBadges from 'modules/DigitalBadges/en.json';
import elementaryCareers from 'modules/ElementaryCareers/en.json';
import elementaryCheckins from 'modules/ElementaryCheckins/en.json';
import elementaryStaffDashboard from 'modules/ElementaryStaffDashboard/en.json';
import elementaryStudentCasefile from 'modules/ElementaryStudentCasefile/en.json';
import employerShowcase from 'modules/EmployerShowcase/en.json';
import experienceTracking from 'modules/ExperienceTracking/en.json';
import fafsaReportingAndTracking from 'modules/FAFSAReportingAndTracking/en.json';
import finalList from 'modules/FinalList/en.json';
import guardians from 'modules/Guardians/en.json';
import indicatorRequirementClusterPortal from 'modules/IndicatorRequirementClusterPortal/en.json';
import industryPartnerAnalytics from 'modules/IndustryPartnerAnalytics/en.json';
import industryPartnerCRM from 'modules/IndustryPartnerCRM/en.json';
import industryPartnerProgramManagement from 'modules/IndustryPartnerProgramManagement/en.json';
import keyReadinessIndicators from 'modules/KeyReadinessIndicators/en.json';
import learningTasks from 'modules/LearningTasks/en.json';
import lessonLibrary from 'modules/LessonLibrary/en.json';
import lifeSimulator from 'modules/LifeSimulator/en.json';
import loginMethods from 'modules/LoginMethods/en.json';
import mentorVideos from 'modules/MentorVideos/en.json';
import messageCenter from 'modules/MessageCenter/en.json';
import newsfeed from 'modules/Newsfeed/en.json';
import notifications from 'modules/Notifications/en.json';
import onboardingAndLogin from 'modules/OnboardingAndLogin/en.json';
import opportunities from 'modules/Opportunities/en.json';
import opportunityManagement from 'modules/OpportunityManagement/en.json';
import personalizedPlans from 'modules/PersonalizedPlans/en.json';
import publicCourseCatalog from 'modules/PublicCourseCatalog/en.json';
import recordCenter from 'modules/RecordCenter/en.json';
import scholarshipManagement from 'modules/ScholarshipManagement/en.json';
import scholarshipMatching from 'modules/ScholarshipMatching/en.json';
import schoolProfile from 'modules/SchoolProfile/en.json';
import schoolSearch from 'modules/SchoolSearch/en.json';
import staffAccountManagement from 'modules/StaffAccountManagement/en.json';
import staffDashboard from 'modules/StaffDashboard/en.json';
import studentCasefile from 'modules/StudentCasefile/en.json';
import studentDashboard from 'modules/StudentDashboard/en.json';
import studentGoals from 'modules/StudentGoals/en.json';
import studentPathways from 'modules/StudentPathways/en.json';
import studentPlanListing from 'modules/StudentPlanListing/en.json';
import studentProfile from 'modules/StudentProfile/en.json';
import surveys from 'modules/Surveys/en.json';
import surveyTask from 'modules/SurveyTask/en.json';
import taskExperience from 'modules/TaskExperience/en.json';
import testScores from 'modules/TestScores/en.json';
import virtualTours from 'modules/VirtualTours/en.json';
import welcomeWidget from 'modules/WelcomeWidget/en.json';

export default {
  ...accountabilitySystemAnalytics,
  ...accountabilitySystemSetup,
  ...accountSettings,
  ...accountSetupV2,
  ...activityTaskExperience,
  ...alumniTakingSurveys,
  ...alumniSurveys,
  ...assessments,
  ...authentication,
  ...careerCenter,
  ...collegeCosts,
  ...common,
  ...courseCatalog,
  ...courseCatalogDistrictConfig,
  ...coursePlanner,
  ...coursePlanning,
  ...credentialWallet,
  ...digitalBadges,
  ...elementaryCareers,
  ...elementaryCheckins,
  ...elementaryStaffDashboard,
  ...elementaryStudentCasefile,
  ...employerShowcase,
  ...experienceTracking,
  ...fafsaReportingAndTracking,
  ...finalList,
  ...guardians,
  ...indicatorRequirementClusterPortal,
  ...industryPartnerAnalytics,
  ...industryPartnerCRM,
  ...industryPartnerProgramManagement,
  ...keyReadinessIndicators,
  ...learningTasks,
  ...lessonLibrary,
  ...lifeSimulator,
  ...loginMethods,
  ...mentorVideos,
  ...messageCenter,
  ...newsfeed,
  ...notifications,
  ...onboardingAndLogin,
  ...opportunities,
  ...opportunityManagement,
  ...personalizedPlans,
  ...publicCourseCatalog,
  ...recordCenter,
  ...scholarshipManagement,
  ...scholarshipMatching,
  ...schoolProfile,
  ...schoolSearch,
  ...staffAccountManagement,
  ...staffDashboard,
  ...studentCasefile,
  ...studentDashboard,
  ...studentGoals,
  ...studentPathways,
  ...studentPlanListing,
  ...studentProfile,
  ...surveys,
  ...surveyTask,
  ...taskExperience,
  ...testScores,
  ...virtualTours,
  ...welcomeWidget,
};
